/**
 * Project: redwood-ui-components
 * FilePath: /src/client/app/applications/Table/Table.js
 * File: Table.js
 * Created Date: Friday, January 4th 2019, 11:15:28 am
 * Author: Craig Bojko
 * -----
 * Last Modified: Fri Apr 05 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Pixel Ventures Ltd.
 * ------------------------------------
 */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { FusePageSimple } from 'modules/@fuse'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import { Table } from 'papyrus-ui-components/packages/papyrus-table'

const _props = require('./__data__/apiProjects.json')

const styles = theme => ({
  layoutRoot: {}
})

class PapyrusTableSandbox extends Component {
  render () {
    const {
      loading,
      typeDefLoading,
      classes
    } = this.props

    return typeDefLoading || loading ? (
      <p>Loading...</p>
    ) : (
      <FusePageSimple
        classes={{
          root: classes.layoutRoot
        }}
        content={
          <div style={{ height: '100vh' }}>
            <Table
              className='anexsys-grid'
              resizable
              expandedRow
              panelIdentifier='PROJECT_PANEL'
              entities={_props.projects}
              typeDefinition={_props.project_def}
            />
          </div>
        }
        onRef={instance => {
          this.pageLayout = instance
        }}
      />
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({

  }, dispatch)
}

function mapStateToProps ({ projects }) {
  return {}
}

export default
withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(PapyrusTableSandbox)
  )
)
